const EQUIPMENT_ROOT_PATH = 'https://4shc66ds38.execute-api.us-east-1.amazonaws.com/equipment';

export const updateTokenEquipment = async (tokenId, itemTokenIds, signature, message, network) => {
  const requestUrl = `${EQUIPMENT_ROOT_PATH}/${tokenId}`;
  const response = await fetch(requestUrl, {
    method: 'POST',
    body: JSON.stringify({ items: itemTokenIds, signature, message, network })
  });
  if (!response.ok) {
    throw new Error('Failed to update inventory!')
  }
};
